module.exports = __webpack_public_path__ + "static/media/logo172.ac130499.png";